import React from 'react';
import './App.css';
import { Spin } from 'antd';
import './antd.css';
import { BrowserRouter as Router } from "react-router-dom";
import Routes from './routes/Routes';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-table-6/react-table.css';
import { askForPermissioToReceiveNotifications } from './push-notification';
import { MediaContextProvider } from "./AppMedia";
import UserSettingProvider from './hooks/UserSettingProvider';
import WindowDimensionProvider from './hooks/WindowDimensionProvider';
import { ConfigProvider } from 'antd';
import { PRIMARY_COLOR, WHITE_COLOR } from './constance/color';


toast.configure();
function App() {

  React.useEffect(() => {
    if (!localStorage.getItem('notification-token')) {
      askForPermissioToReceiveNotifications();
    }
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: PRIMARY_COLOR,
          colorBgLayout: WHITE_COLOR,
        },
      }}>
      <WindowDimensionProvider>
        <MediaContextProvider>
          <UserSettingProvider>
            <React.Suspense fallback={
              <Spin fullscreen size='large' />
            }>
              <Router>
                <div className='App'>
                  <Routes />
                </div>
              </Router>
            </React.Suspense>
          </UserSettingProvider>
        </MediaContextProvider>
      </WindowDimensionProvider>
    </ConfigProvider>
  );
}

export default App;